import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Block, BlockHead, BlockTitle, DataTableHead, DataTableItem, DataTableRow } from '../../../../components/Component';
import { formatNumber } from '../../../../utils/Utils';
import AuthTenantNoData from '../../../error/AuthTenantNoData';
import { download, generateCsv, mkConfig } from 'export-to-csv';
import { Button } from 'reactstrap';

const ProductTypeDistributionOrderReport = ({ data, tenant_info }) => {

  const [page_data, setPageData] = useState(data);

  useEffect(() => {
    setPageData(data);
  }, [data]);

  const exportProductTypeOrderListToCSV = () => {
    const list = page_data?.product_type_distribution_list;

    if (!list || list.length === 0)
    {
      console.warn("No product type distribution data available for export.");
      return;
    }

    const csvData = list.map(item => ({
      product_type: item.product_type || "--",
      orders: item.count || 0,
      units_ordered: item.units_ordered || 0,
      value_ordered: item.value_ordered || 0,
      currency: "ZMW"
    }));

    const csvConfig = mkConfig({
      filename: `product_type_order_list`,
      fieldSeparator: ",",
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: true,
    });

    const csv = generateCsv(csvConfig)(csvData);
    download(csvConfig)(csv);
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <motion.div
          className="bg-light border-start border-primary ps-3 py-2 mb-3 rounded"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.4, delay: 0.1 }}
        >
          <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
            Kindly Note that Product Type Distribution Excludes Cancelled/Rejected Orders and is Based off of the Main Order Status.
          </p>
        </motion.div>
        <BlockHead>
          <BlockTitle tag="h5" className="mt-2">Product Type Order List</BlockTitle>
        </BlockHead>
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
          <Button color="primary" onClick={exportProductTypeOrderListToCSV}>
            Export Product Type Orders CSV
          </Button>
        </div>
        <Block>
          {
            page_data?.product_type_distribution_list && page_data?.product_type_distribution_list?.length > 0 ?
              <>
                <div className="nk-tb-list is-separate is-medium mb-3">
                  <DataTableHead className="nk-tb-item">
                    <DataTableRow><span className="sub-text">Product Type</span></DataTableRow>
                    <DataTableRow><span className="sub-text">Orders</span></DataTableRow>
                    <DataTableRow><span className="sub-text">Units Ordered</span></DataTableRow>
                    <DataTableRow><span className="sub-text">Value of Units Ordered</span></DataTableRow>
                    {/* <DataTableRow><span className="sub-text">Action</span></DataTableRow> */}
                  </DataTableHead>


                  {page_data?.product_type_distribution_list?.map((item) => (
                    <DataTableItem key={item.id}>
                      <DataTableRow>
                        <div className="user-card">
                          <div className="user-info">
                            <span className="tb-lead">
                              {item?.product_type || "--"}
                            </span>
                          </div>
                        </div>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="tb-lead">
                          {item?.count || "--"}
                        </span>
                      </DataTableRow>
                      <DataTableRow>
                        <div className="user-card">
                          <div className="user-info">
                            <span className="tb-lead">{item?.units_ordered ? formatNumber(item?.units_ordered) : "--"}</span>
                            <span></span>
                          </div>
                        </div>
                      </DataTableRow>
                      <DataTableRow>
                        <div className="user-card">
                          <div className="user-info">
                            <span className="tb-lead">{item?.value_ordered ? `${formatNumber(item?.value_ordered)} ZMW` : "--"}</span>
                            <span></span>
                          </div>
                        </div>
                      </DataTableRow>
                      {/* <DataTableRow>
                                <Link to={`/${tenant_info.url_prefix}/orders/${item?.order_ref_number}`}>
                                  <Button color="primary" size="sm" className="btn btn-dim">
                                    View
                                  </Button>
                                </Link>
                              </DataTableRow> */}
                    </DataTableItem>
                  ))}
                </div>
              </>
              :
              <>
                <AuthTenantNoData tenant_info={tenant_info} no_data_message="No Product Type Distribution Data Found." />
              </>
          }
        </Block>
      </motion.div>

    </>
  );
};

export default ProductTypeDistributionOrderReport;